import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { RegisterOptions, UseFormReturn } from "react-hook-form";
import { useGlobalData } from "../../GlobalDataProvider";
import { getValueByString } from "../Utils";
import FieldError from "./FieldError";

interface IProps {
  label: string;
  fieldName: string;
  formHook: UseFormReturn;
  options?: RegisterOptions;

  step?: number;
  tooltipId?: string;
  isDisabled?: boolean;
  min?: number;
  max?: number;
}

const CheckboxEditor = ({ label, fieldName, formHook, options, step, tooltipId, isDisabled, min, max }: IProps) => {
  const { register, formState } = formHook;
  const globalData = useGlobalData();
  const errors = formState.errors;

  const isInValid: any = getValueByString(errors, fieldName);

  options = options || {};
  if (options) {
    if (!options.valueAsNumber && !options.setValueAs) options.valueAsNumber = true;
  }

  const renderTooltip = (props: any) => {
    if (tooltipId && globalData.data?.Tooltip.mapTooltip[tooltipId])
      return (
        <Tooltip {...props} className="defaultTooltip">
          <span style={{ whiteSpace: "pre-line" }}>{globalData.data?.Tooltip.mapTooltip[tooltipId]}</span>
        </Tooltip>
      );
    else return <></>;
  };

  const getCheckboxEditor = () => {
    var htmlPart;

    //Input group base
    htmlPart = (
      <OverlayTrigger placement="top" overlay={renderTooltip}>
        <div className={"form-check w-100"}>
          {isDisabled ? (
            <input value={""} type="checkbox" disabled={isDisabled} className={"form-check-input"} />
          ) : (
            <input
              id={label}
              type="checkbox"
              min={min}
              max={max}
              step={step}
              disabled={isDisabled}
              {...register(fieldName, options)}
              className={"form-check-input " + (isInValid ? "is-invalid" : "")} aria-invalid={!!isInValid}
            />
          )}
          {label && (
            <label htmlFor={label} className="form-check-label">
              {label}
            </label>
          )}

        </div>
      </OverlayTrigger>
    );

    //Label if exists
    // if (label) {
    //   htmlPart = (
    //     <label className="form-label w-100">
    //       {label}
    //       {htmlPart}
    //     </label>
    //   );
    // }

    //Validation message above the checkbox
    htmlPart = (
      <div className="w-100">
        <FieldError error={isInValid} />
        {htmlPart}
      </div>
    );

    htmlPart = <div className="input-group has-validation">{htmlPart}</div>;

    return htmlPart;
  };

  return <>{getCheckboxEditor()}</>;
};

export default CheckboxEditor;
